import TemplateTransformer from '@intercom/embercom-composer/lib/template-transformer';
import Templater from '@intercom/embercom-composer/lib/templater';
import $ from 'jquery';
import { bool, not } from '@ember/object/computed';
import { scheduleOnce, later } from '@ember/runloop';
import Em from 'ember';
export default Em.Mixin.create({
  templateInfo: null,
  isBoxVisible: true,
  isTemplateVisible: not('isBoxVisible'),
  hasTemplate: bool('templateInfo.html'),
  htmlBlocks: Em.computed('composerState.blockList.[]', function () {
    return this.get('composerState.blockList').filterBy('type', 'html');
  }),
  didInsertTemplating: Em.on('didInsertElement', function () {
    this.set('templater', new Templater($(this.element)));
    this.templateDidChange();
  }),
  willDestroyTemplating: Em.on('willDestroyElement', function () {
    this.get('templater').destroy();
  }),
  templateDidChange: Em.observer({
    dependentKeys: ['templateInfo.html', 'templateIsEmpty'],
    fn() {
      if (!this.get('templater')) {
        return;
      }
      if (this.get('hasTemplate')) {
        this.get('templater').removeTemplate();
        this.set('isBoxVisible', false);
        this.transformTemplateAndApply();
      } else {
        this.get('templater').removeTemplate();
        this.set('isBoxVisible', true);
        this.send('onComposerReady');
      }
    },
    sync: true
  }),
  transformTemplateAndApply() {
    let templateInfo = this.get('templateInfo');
    let templateTransformer = new TemplateTransformer(templateInfo);
    this.set('templateTransformer', templateTransformer);
    templateTransformer.process().then(this.gotTransformedTemplate.bind(this));
  },
  isReadOnlyChanged: Em.observer({
    dependentKeys: ['isReadOnly'],
    fn() {
      if (this.get('hasTemplate')) {
        this.get('templater').removeTemplate();
        scheduleOnce('afterRender', this, this.applyCurrentTemplate);
      }
    },
    sync: true
  }),
  gotTransformedTemplate(transformedTemplate) {
    if (!this.get('isDestroying')) {
      this.set('transformedTemplate', transformedTemplate);
      scheduleOnce('afterRender', this, this.applyCurrentTemplate);
    }
  },
  applyCurrentTemplate() {
    let transformedTemplate = this.get('transformedTemplate');
    if (!transformedTemplate) {
      return;
    }
    let templater = this.get('templater');
    templater.applyTemplate(transformedTemplate, this.get('isReadOnly'));
    this.get('templateTransformer').transformHtmlBlockStyles(this.get('htmlBlocks'));
    this.refreshEditor();
    //TODO NOLANEO - Ideally we need some way to wait for all the assets to load.
    later(this, function () {
      if (!this.isDestroying) {
        this.send('onComposerReady');
      }
    }, 250);
  },
  refreshEditor() {
    let editorView = this.get('editorView');
    editorView.setEditorDimensions();
    editorView.updateDom();
  }
});